<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-Post-4_approval_militaryforce-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 660}
    <div id="g-Post-4_approval_militaryforce-xs" class="g-artboard" style="">
      <div style="padding: 0 0 79.697% 0;"></div>
      <div
        id="g-Post-4_approval_militaryforce-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/Post-4_approval_militaryforce-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:7.461%;margin-top:-18.6px;left:27.8789%;width:60px;"
      >
        <p class="g-pstyle0">Too</p>
        <p class="g-pstyle0">much</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:7.461%;margin-top:-18.6px;left:56.7529%;width:64px;"
      >
        <p class="g-pstyle0">About</p>
        <p class="g-pstyle0">right</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:7.461%;margin-top:-18.6px;left:81.7577%;width:73px;"
      >
        <p class="g-pstyle0">Not</p>
        <p class="g-pstyle0">enough</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:21.5295%;margin-top:-9.6px;left:28.7934%;width:53px;"
      >
        <p class="g-pstyle1">56%</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:21.5295%;margin-top:-9.6px;left:57.2282%;width:53px;"
      >
        <p class="g-pstyle1">35%</p>
      </div>
      <div
        id="g-ai0-6"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:21.5295%;margin-top:-9.6px;left:84.1183%;width:45px;"
      >
        <p class="g-pstyle2">5%</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:21.5295%;margin-top:-9.6px;left:-0.0592%;width:109px;"
      >
        <p class="g-pstyle3">All U.S. adults</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-xs g-aiAbs"
        style="top:34.981%;left:-0.0591%;width:45.4545%;"
      >
        <p>By party affiliation</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:51.1873%;margin-top:-18.6px;left:27.8789%;width:58px;"
      >
        <p class="g-pstyle0">Too</p>
        <p class="g-pstyle0">much</p>
      </div>
      <div
        id="g-ai0-10"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:51.1873%;margin-top:-18.6px;left:56.7529%;width:62px;"
      >
        <p class="g-pstyle0">About</p>
        <p class="g-pstyle0">right</p>
      </div>
      <div
        id="g-ai0-11"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:51.1873%;margin-top:-18.6px;left:81.7577%;width:71px;"
      >
        <p class="g-pstyle0">Not</p>
        <p class="g-pstyle0">enough</p>
      </div>
      <div
        id="g-ai0-12"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:64.8755%;margin-top:-9.6px;left:36.0661%;width:51px;"
      >
        <p class="g-pstyle2">23%</p>
      </div>
      <div
        id="g-ai0-13"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:64.8755%;margin-top:-9.6px;left:57.6673%;width:50px;"
      >
        <p class="g-pstyle1">73%</p>
      </div>
      <div
        id="g-ai0-14"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:64.8755%;margin-top:-9.6px;left:83.5409%;width:43px;"
      >
        <p class="g-pstyle2">3%</p>
      </div>
      <div
        id="g-ai0-15"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:64.8755%;margin-top:-9.6px;left:-0.0592%;width:98px;"
      >
        <p class="g-pstyle3">Republicans</p>
      </div>
      <div
        id="g-ai0-16"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:79.3242%;margin-top:-9.6px;left:28.7934%;width:51px;"
      >
        <p class="g-pstyle1">87%</p>
      </div>
      <div
        id="g-ai0-17"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:79.3242%;margin-top:-9.6px;left:59.5452%;width:43px;"
      >
        <p class="g-pstyle2">7%</p>
      </div>
      <div
        id="g-ai0-18"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:79.3242%;margin-top:-9.6px;left:84.4068%;width:44px;"
      >
        <p class="g-pstyle2">6%</p>
      </div>
      <div
        id="g-ai0-19"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:79.3242%;margin-top:-9.6px;left:-0.0592%;width:89px;"
      >
        <p class="g-pstyle3">Democrats</p>
      </div>
      <div
        id="g-ai0-20"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:93.7728%;margin-top:-9.6px;left:28.7934%;width:53px;"
      >
        <p class="g-pstyle1">60%</p>
      </div>
      <div
        id="g-ai0-21"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:93.7728%;margin-top:-9.6px;left:57.6673%;width:52px;"
      >
        <p class="g-pstyle1">26%</p>
      </div>
      <div
        id="g-ai0-22"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:93.7728%;margin-top:-9.6px;left:84.4068%;width:44px;"
      >
        <p class="g-pstyle2">6%</p>
      </div>
      <div
        id="g-ai0-23"
        class="g-xs g-aiAbs g-aiPointText"
        style="top:93.7728%;margin-top:-9.6px;left:-0.0592%;width:57px;"
      >
        <p class="g-pstyle3">Other</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660}
    <div id="g-Post-4_approval_militaryforce-md" class="g-artboard" style="">
      <div style="padding: 0 0 35.4545% 0;"></div>
      <div
        id="g-Post-4_approval_militaryforce-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/Post-4_approval_militaryforce-md.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-md g-aiAbs g-aiPointText"
        style="top:6.4804%;margin-top:-10.2px;left:15.8126%;width:89px;"
      >
        <p class="g-pstyle0">Too much</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-md g-aiAbs g-aiPointText"
        style="top:6.4804%;margin-top:-10.2px;left:50.0176%;width:101px;"
      >
        <p class="g-pstyle0">About right</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-md g-aiAbs g-aiPointText"
        style="top:6.4804%;margin-top:-10.2px;left:79.639%;width:103px;"
      >
        <p class="g-pstyle0">Not enough</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-md g-aiAbs g-aiPointText"
        style="top:17.5915%;margin-top:-10.2px;left:16.8959%;width:54px;"
      >
        <p class="g-pstyle1">56%</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-md g-aiAbs g-aiPointText"
        style="top:17.5915%;margin-top:-10.2px;left:51.101%;width:53px;"
      >
        <p class="g-pstyle1">35%</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-md g-aiAbs g-aiPointText"
        style="top:17.5915%;margin-top:-10.2px;left:82.4352%;width:45px;"
      >
        <p class="g-pstyle2">5%</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-md g-aiAbs g-aiPointText"
        style="top:17.5915%;margin-top:-10.2px;left:-0.009%;width:115px;"
      >
        <p class="g-pstyle3">All U.S. adults</p>
      </div>
      <div
        id="g-ai1-8"
        class="g-md g-aiAbs"
        style="top:33.7607%;left:-0.009%;width:20.7576%;"
      >
        <p>By party affiliation</p>
      </div>
      <div
        id="g-ai1-9"
        class="g-md g-aiAbs g-aiPointText"
        style="top:49.2154%;margin-top:-10.2px;left:15.8126%;width:89px;"
      >
        <p class="g-pstyle0">Too much</p>
      </div>
      <div
        id="g-ai1-10"
        class="g-md g-aiAbs g-aiPointText"
        style="top:49.2154%;margin-top:-10.2px;left:50.0176%;width:101px;"
      >
        <p class="g-pstyle0">About right</p>
      </div>
      <div
        id="g-ai1-11"
        class="g-md g-aiAbs g-aiPointText"
        style="top:49.2154%;margin-top:-10.2px;left:79.639%;width:103px;"
      >
        <p class="g-pstyle0">Not enough</p>
      </div>
      <div
        id="g-ai1-12"
        class="g-md g-aiAbs g-aiPointText"
        style="top:60.3265%;margin-top:-10.2px;left:16.8959%;width:53px;"
      >
        <p class="g-pstyle1">23%</p>
      </div>
      <div
        id="g-ai1-13"
        class="g-md g-aiAbs g-aiPointText"
        style="top:60.3265%;margin-top:-10.2px;left:51.101%;width:52px;"
      >
        <p class="g-pstyle1">73%</p>
      </div>
      <div
        id="g-ai1-14"
        class="g-md g-aiAbs g-aiPointText"
        style="top:60.3265%;margin-top:-10.2px;left:81.7513%;width:44px;"
      >
        <p class="g-pstyle2">3%</p>
      </div>
      <div
        id="g-ai1-15"
        class="g-md g-aiAbs g-aiPointText"
        style="top:60.3265%;margin-top:-10.2px;left:-0.009%;width:103px;"
      >
        <p class="g-pstyle3">Republicans</p>
      </div>
      <div
        id="g-ai1-16"
        class="g-md g-aiAbs g-aiPointText"
        style="top:76.5658%;margin-top:-10.2px;left:16.8959%;width:53px;"
      >
        <p class="g-pstyle1">87%</p>
      </div>
      <div
        id="g-ai1-17"
        class="g-md g-aiAbs g-aiPointText"
        style="top:76.5658%;margin-top:-10.2px;left:53.3252%;width:44px;"
      >
        <p class="g-pstyle2">7%</p>
      </div>
      <div
        id="g-ai1-18"
        class="g-md g-aiAbs g-aiPointText"
        style="top:76.5658%;margin-top:-10.2px;left:82.7771%;width:45px;"
      >
        <p class="g-pstyle2">6%</p>
      </div>
      <div
        id="g-ai1-19"
        class="g-md g-aiAbs g-aiPointText"
        style="top:76.5658%;margin-top:-10.2px;left:-0.009%;width:93px;"
      >
        <p class="g-pstyle3">Democrats</p>
      </div>
      <div
        id="g-ai1-20"
        class="g-md g-aiAbs g-aiPointText"
        style="top:92.8052%;margin-top:-10.2px;left:16.8959%;width:55px;"
      >
        <p class="g-pstyle1">60%</p>
      </div>
      <div
        id="g-ai1-21"
        class="g-md g-aiAbs g-aiPointText"
        style="top:92.8052%;margin-top:-10.2px;left:51.101%;width:54px;"
      >
        <p class="g-pstyle1">26%</p>
      </div>
      <div
        id="g-ai1-22"
        class="g-md g-aiAbs g-aiPointText"
        style="top:92.8052%;margin-top:-10.2px;left:82.7771%;width:45px;"
      >
        <p class="g-pstyle2">6%</p>
      </div>
      <div
        id="g-ai1-23"
        class="g-md g-aiAbs g-aiPointText"
        style="top:92.8052%;margin-top:-10.2px;left:-0.009%;width:60px;"
      >
        <p class="g-pstyle3">Other</p>
      </div>
    </div>
  {/if}
</div>

<!-- End ai2html - 2026-03-02 12:38 -->

<!-- Generated by ai2html v0.100.0 - 2026-03-02 12:38 -->
<!-- ai file: Post-4_approval_militaryforce.ai -->
<style lang="scss">
  #g-Post-4_approval_militaryforce-box,
  #g-Post-4_approval_militaryforce-box .g-artboard {
    margin: 0 auto;
  }
  #g-Post-4_approval_militaryforce-box p {
    margin: 0;
  }
  #g-Post-4_approval_militaryforce-box .g-aiAbs {
    position: absolute;
  }
  #g-Post-4_approval_militaryforce-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-Post-4_approval_militaryforce-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-Post-4_approval_militaryforce-xs {
    position: relative;
    overflow: hidden;
  }
  #g-Post-4_approval_militaryforce-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 18px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-4_approval_militaryforce-xs .g-pstyle0 {
    height: 18px;
  }
  #g-Post-4_approval_militaryforce-xs .g-pstyle1 {
    height: 18px;
    color: rgb(255, 255, 255);
  }
  #g-Post-4_approval_militaryforce-xs .g-pstyle2 {
    height: 18px;
    color: rgb(64, 64, 64);
  }
  #g-Post-4_approval_militaryforce-xs .g-pstyle3 {
    font-weight: 300;
    height: 18px;
  }
  #g-Post-4_approval_militaryforce-md {
    position: relative;
    overflow: hidden;
  }
  #g-Post-4_approval_militaryforce-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-Post-4_approval_militaryforce-md .g-pstyle0 {
    height: 19px;
  }
  #g-Post-4_approval_militaryforce-md .g-pstyle1 {
    height: 19px;
    color: rgb(255, 255, 255);
  }
  #g-Post-4_approval_militaryforce-md .g-pstyle2 {
    height: 19px;
    color: rgb(64, 64, 64);
  }
  #g-Post-4_approval_militaryforce-md .g-pstyle3 {
    font-weight: 300;
    height: 19px;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
